module.exports = __webpack_public_path__ + "static/img/img_06.ad6d85e3.png";